// src/api/chat.ts
//
// Typed client for the chat service.

import { getChatServiceUrl } from '../utils/backend'
import { createApiClient } from './base'

const chatClient = createApiClient(getChatServiceUrl)

// ---------------------------------------------------------------------------
// Types
// ---------------------------------------------------------------------------

export type ChatSession = {
  id: string
  title?: string
  date_created?: string
}

// ---------------------------------------------------------------------------
// Chat sessions
// ---------------------------------------------------------------------------

export async function listChats(
  userId: string,
  signal?: AbortSignal,
): Promise<ChatSession[]> {
  const params = new URLSearchParams({ user_id: userId })
  const data = await chatClient.request<ChatSession[]>(
    `/chat/list/?${params.toString()}`,
    { signal },
  )
  return data ?? []
}

export async function getChatTranscript(
  chatId: string,
  userId: string,
  signal?: AbortSignal,
): Promise<string> {
  const params = new URLSearchParams({ id: chatId, user_id: userId })
  return chatClient.request<string>(`/chat/transcript/?${params.toString()}`, { signal })
}

export async function archiveChat(chatId: string, userId: string): Promise<void> {
  await chatClient.request('/chat/update/archive/', {
    method: 'POST',
    body: { id: chatId, user_id: userId },
  })
}

export async function unarchiveChat(chatId: string, userId: string): Promise<void> {
  await chatClient.request(`/chats/${encodeURIComponent(chatId)}`, {
    method: 'PATCH',
    body: { user_id: userId, archived: false },
  })
}

export async function listArchivedChats(
  userId: string,
  signal?: AbortSignal,
): Promise<ChatSession[]> {
  const params = new URLSearchParams({ user_id: userId })
  const data = await chatClient.request<ChatSession[]>(
    `/chat/list/archived/?${params.toString()}`,
    { signal },
  )
  return data ?? []
}

export async function deleteChat(chatId: string, userId: string): Promise<void> {
  await chatClient.request('/chat/delete/', {
    method: 'POST',
    body: { id: chatId, user_id: userId },
  })
}
